// Names the marketing box wording a student or teacher saw; it is stored on their consent row.
// When the copy of `unified.onboarding.marketingOptIn` (students, MARKETING_WORDING_VERSION) or
// `schools.signup.form.marketingOptIn` (teachers, EDUCATOR_MARKETING_WORDING_VERSION) changes:
//   1. change the string in packages/i18n/locales/en-US/unified.json or schools.json
//   2. bump the matching constant (e.g. 2026-11-v2) and the pinned copy in marketingConsent.spec.ts
//   3. add the new version to consent_wording_versions.student or .educator in laravel/config/marketing.php, keeping the old ones
export const MARKETING_WORDING_VERSION = '2026-09-v1';
export const EDUCATOR_MARKETING_WORDING_VERSION = '2026-11-educators-v1';
